/**
 * app.config.js — APP IDENTITY & AUTH CONFIG
 *
 * Branding, theme, and auth configuration only.
 * Routes are self-declared by each page (export const route).
 * Nav items are self-declared by each page (export const nav).
 * Tables are auto-discovered from mockData/*.json files.
 */

export const APP_CONFIG = {
  name: 'PicketOps',
  tagline: 'The revenue operating system for fence contractors.',
  emoji: '⚒️',
  icon: 'Fence',

  defaultTheme: 'dark',
  defaultLoginRoute: '/contractor/login',
};

/**
 * Per-role auth routes and copy.
 * null when the app has no distinct profiles (uses GENERIC_AUTH instead).
 */
export const AUTH_PROFILES = [
  {
    key: 'admin',
    name: 'Admin_c',
    label: 'Admin',
    profileSlug: '|/YKU59efm6WdTcPzoV/PzKROk7uDN/5+nctE76Z830w=',
    redirectAfterAuth: '/dashboard',
    hasSignup: false,
    reportsTo: null,
    authPage: {
      loginTitle: 'PicketOps admin',
      signupTitle: 'Create admin account',
      loginDescription: 'Sign in to manage the PicketOps workspace.',
      signupDescription: null,
    },
    altLinksLeadIn: 'Running your fence business?',
    altLinks: [{ href: '/contractor/login', label: 'Sign in as a Contractor' }],
  },
  {
    key: 'contractor',
    name: 'Contractor_c',
    label: 'Contractor',
    profileSlug: '|J6Q6wyYVmPSiGaP6IPvq2zTa5xlT77EH0l0NsmnIivc=',
    redirectAfterAuth: '/dashboard',
    hasSignup: true,
    reportsTo: 'Admin_c',
    authPage: {
      loginTitle: 'Welcome back to PicketOps',
      signupTitle: 'Create your PicketOps account',
      loginDescription: 'Sign in to your fence contractor revenue workspace.',
      signupDescription: 'Create your account, then save your company profile and contact support for operator activation. Signup does not start a trial or charge you.',
    },
    altLinksLeadIn: 'PicketOps administrator?',
    altLinks: [{ href: '/admin/login', label: 'Sign in as an Admin' }],
  },
];

/**
 * Fallback auth copy when AUTH_PROFILES is null or URL profile doesn't match.
 */
export const GENERIC_AUTH = {
  loginTitle: 'Welcome back',
  signupTitle: 'Create account',
  loginDescription: null,
  signupDescription: null,
  redirectAfterAuth: '/dashboard',
};
